import { render, staticRenderFns } from "./AuthenticityDeadline.vue?vue&type=template&id=73a1edfe&"
import script from "./AuthenticityDeadline.vue?vue&type=script&lang=js&"
export * from "./AuthenticityDeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports